import { CustomerPaymentMethod } from './customer-payment-method';
import { Cart } from './cart';
import { CustomerCreditCard } from './customer-credit-card';
import {Discount} from "./discount";

export class UpgradeCheckout {
  newPlanId: string;
  contractCode: string;
  paymentData: CustomerPaymentMethod;
  upgradeCart: Cart;
  validationToken: string;
  discounts: Array<Discount>;
  customValue: number;

  constructor(upgradeData?: any) {
    if (upgradeData) {
      this.validationToken = upgradeData.validationToken;
      this.newPlanId = upgradeData.newPlanId;
      this.contractCode = upgradeData.contractCode;
      this.customValue = upgradeData.customValue ? upgradeData.customValue : 0;

      if (upgradeData.paymentData && upgradeData.paymentData.identifier === 'BANK_BILLET') {
        this.paymentData = new CustomerPaymentMethod('BANK_BILLET');
      } else if (upgradeData.paymentData && upgradeData.paymentData.identifier === 'PIX') {
        this.paymentData = new CustomerPaymentMethod('PIX');
      } else if (upgradeData.paymentData && upgradeData.paymentData.identifier === 'CREDIT_CARD') {
        this.paymentData = new CustomerPaymentMethod('CREDIT_CARD');
        this.paymentData.sameCard = upgradeData.paymentData.sameCard;
        this.paymentData.paymentConditionIdentifier = upgradeData.paymentData.paymentConditionIdentifier;
        this.paymentData.card = new CustomerCreditCard(upgradeData.paymentData.card);
        this.paymentData.isAdyen = upgradeData.paymentData.isAdyen;
        this.paymentData.nickname = upgradeData.paymentData.nickname;
        this.paymentData.defaultCard = upgradeData.paymentData.defaultCard;
        this.paymentData.saveCard = upgradeData.paymentData.saveCard;
        this.paymentData.accountPaymentDataId = upgradeData.paymentData.accountPaymentDataId;
      }

      this.upgradeCart = upgradeData.upgradeCart ? new Cart(upgradeData.upgradeCart) : null;

      if (this.paymentData.card && this.paymentData.card.cardSecurityCode) {
        this.paymentData.card.cardSecurityCode = null;
      }

      this.discounts = upgradeData.discounts ? upgradeData.discounts.map(discount => new Discount(discount)): [];
    }
  }
}
